import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { StockContainersInfo } from './types';

type GetStockContainersArgs = {
  armador: string;
};

type GetStockContainersResponse = {
  state: number;
  value: StockContainersInfo[];
};

export const getStockContainers = async ({
  armador,
}: GetStockContainersArgs): Promise<StockContainersInfo[]> => {
  try {
    const res = await apiClient.post<GetStockContainersResponse>(
      Endpoints.StockContainers,
      {
        armador,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
